import Swal from "sweetalert2";

/**
 * Avisos de la aplicación.
 *
 * Se usa el diálogo de SweetAlert tal cual viene; lo único propio es que los
 * colores salen del tema. La clase `sup-swal-popup` pinta el fondo y los textos
 * desde `src/styles/modals.scss`, y los botones se siguen estilando con el
 * mecanismo de SweetAlert, que los quiere como color literal.
 */
const customClass = { popup: "sup-swal-popup" };

/**
 * SweetAlert escribe el color del botón en línea, así que no admite `var()`.
 * Se resuelve el token contra el documento en el momento de abrir el diálogo,
 * que es lo que lo hace seguir al modo claro/oscuro.
 */
const token = (name, fallback) => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

const fire = (options) =>
  Swal.fire({
    customClass,
    confirmButtonColor: token("--sup-brand", "#e53935"),
    cancelButtonColor: token("--sup-ink-3", "#8d8884"),
    ...options,
  });

/** Si `text` viene como objeto (un error de la API), se muestra legible. */
const asText = (text) =>
  typeof text === "object" && text !== null ? JSON.stringify(text, null, 2) : text;

export const ErrorModal = ({ title, text, errorCode, icon = "error" }) => {
  fire({
    title: errorCode ? `Error ${errorCode}: ${title}` : title,
    text: asText(text),
    icon,
    showCancelButton: false,
    confirmButtonText: "Aceptar",
  });

  return <></>;
};

export const ConfirmModal = ({ title, text, onConfirm, onCancel }) => {
  fire({
    title,
    text: asText(text),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    } else if (onCancel) {
      onCancel();
    }
  });

  return <></>;
};

export const SuccessModal = ({ title, text }) => {
  fire({
    title,
    text: asText(text),
    icon: "success",
    confirmButtonText: "Aceptar",
  });
};
